import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-16 md:py-24 bg-white" data-id="element-22">
      <div className="container mx-auto px-4" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-25">
            Contact Us
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-6" data-id="element-26"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-27">
            Get in touch with our team for professional building maintenance
            services in Ajman and Dubai.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-28">
          <div className="bg-gray-50 p-8 rounded-lg" data-id="element-29">
            <h3 className="text-2xl font-bold mb-6 text-gray-900" data-id="element-30">
              Send Us a Message
            </h3>
            <form data-id="element-31">
              <div className="mb-4" data-id="element-32">
                <label htmlFor="name" className="block text-gray-700 mb-2" data-id="element-33">
                  Full Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Your name" data-id="element-34" />
              </div>
              <div className="mb-4" data-id="element-35">
                <label htmlFor="phone" className="block text-gray-700 mb-2" data-id="element-36">
                  Phone Number
                </label>
                <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Your phone number" data-id="element-37" />
              </div>
              <div className="mb-4" data-id="element-38">
                <label htmlFor="email" className="block text-gray-700 mb-2" data-id="element-39">
                  Email Address
                </label>
                <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Your email address" data-id="element-40" />
              </div>
              <div className="mb-4" data-id="element-41">
                <label htmlFor="service" className="block text-gray-700 mb-2" data-id="element-42">
                  Service Required
                </label>
                <select id="service" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-43">
                  <option value="" data-id="element-44">Select a service</option>
                  <option value="ceiling-walls" data-id="element-45">
                    Ceiling & Walls Maintenance
                  </option>
                  <option value="flooring" data-id="element-46">Flooring & Tiling Work</option>
                  <option value="electrical" data-id="element-47">
                    Electrical & Wiring Services
                  </option>
                  <option value="plumbing" data-id="element-48">Plumbing & Water Systems</option>
                  <option value="carpentry" data-id="element-49">Carpentry & Woodwork</option>
                  <option value="interior" data-id="element-50">Interior Decoration & Design</option>
                  <option value="hvac" data-id="element-51">HVAC & AC Repair</option>
                  <option value="general" data-id="element-52">General Building Repairs</option>
                </select>
              </div>
              <div className="mb-6" data-id="element-53">
                <label htmlFor="message" className="block text-gray-700 mb-2" data-id="element-54">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Tell us about your requirements" data-id="element-55"></textarea>
              </div>
              <button type="submit" className="w-full bg-amber-500 hover:bg-amber-600 text-white py-3 px-6 rounded-md font-medium transition-colors" data-id="element-56">
                Submit Request
              </button>
            </form>
          </div>
          <div data-id="element-57">
            <h3 className="text-2xl font-bold mb-6 text-gray-900" data-id="element-58">
              Our Location
            </h3>
            <div className="bg-gray-900 text-white p-8 rounded-lg mb-8" data-id="element-59">
              <div className="flex items-start mb-6" data-id="element-60">
                <MapPin className="mr-4 text-amber-400 flex-shrink-0 mt-1" data-id="element-61" />
                <div data-id="element-62">
                  <h4 className="font-bold text-lg mb-1" data-id="element-63">Address</h4>
                  <p className="text-gray-300" data-id="element-64">
                    Al Jerf 3, Ajman, United Arab Emirates
                  </p>
                </div>
              </div>
              <div className="flex items-start mb-6" data-id="element-65">
                <Phone className="mr-4 text-amber-400 flex-shrink-0 mt-1" data-id="element-66" />
                <div data-id="element-67">
                  <h4 className="font-bold text-lg mb-1" data-id="element-68">Phone</h4>
                  <p className="text-gray-300" data-id="element-69">+971 50 758 3460</p>
                  <p className="text-gray-300" data-id="element-70">+971 56 867 1672</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-71">
                <Mail className="mr-4 text-amber-400 flex-shrink-0 mt-1" data-id="element-72" />
                <div data-id="element-73">
                  <h4 className="font-bold text-lg mb-1" data-id="element-74">Email</h4>
                  <p className="text-gray-300" data-id="element-75">louzan.bm@gmail.com</p>
                </div>
              </div>
            </div>
            <div data-id="element-76">
              <h4 className="text-xl font-bold mb-4 text-gray-900" data-id="element-77">
                Service Areas
              </h4>
              <ul className="space-y-2 text-gray-700" data-id="element-78">
                <li className="flex items-center" data-id="element-79">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mr-2" data-id="element-80"></div>
                  Ajman (All Areas)
                </li>
                <li className="flex items-center" data-id="element-81">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mr-2" data-id="element-82"></div>
                  Dubai (All Areas)
                </li>
                <li className="flex items-center" data-id="element-83">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mr-2" data-id="element-84"></div>
                  Sharjah (Selected Areas)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}